/**
 * Normalize stored country strings (legacy "USA", names) to ISO 3166-1 alpha-2 where possible.
 */
export function normalizeCountryToIso(country) {
  if (country == null || country === '') return '';
  const s = String(country).trim();
  if (!s) return '';
  if (s.length === 2 && /^[a-zA-Z]{2}$/.test(s)) return s.toUpperCase();
  const u = s.toUpperCase().replace(/\./g, '');
  if (u === 'USA' || u === 'US' || u === 'UNITED STATES' || u === 'UNITED STATES OF AMERICA') return 'US';
  if (u === 'INDIA' || u === 'IND' || u === 'IN') return 'IN';
  if (u === 'UK' || u === 'UNITED KINGDOM' || u === 'GREAT BRITAIN' || u === 'GB' || u === 'GBR') return 'GB';
  return '';
}

export function resolveCountryIso(country, allCountries) {
  if (!allCountries?.length) return normalizeCountryToIso(country) || '';
  let iso = normalizeCountryToIso(country);
  if (iso && allCountries.some((c) => (c.isoCode || c.code) === iso)) return iso;
  const lower = String(country || '').trim().toLowerCase();
  const hit = allCountries.find(
    (c) =>
      String(c.name || c.label || '')
        .toLowerCase() === lower ||
      String(c.code || c.isoCode || '')
        .toLowerCase() === lower
  );
  return hit?.isoCode || hit?.code || iso || '';
}

export function isUSCountry(country) {
  const iso = normalizeCountryToIso(country);
  if (iso === 'US') return true;
  const c = String(country || '').trim().toLowerCase();
  return c === '' || c === 'usa' || c === 'united states' || c === 'united states of america';
}

export function isIndiaCountry(country) {
  return normalizeCountryToIso(country) === 'IN' || String(country || '').trim().toLowerCase() === 'india';
}
